export default function /* @ngInject */ stripeLoadSdk($q, stripeConfig) {
    let deferredLoad, script;
    return function() {
        if (!deferredLoad) {
            deferredLoad = $q.defer();
            script = document.createElement('script');
            script.src = stripeConfig.sdkSrc;
            script.onerror = () => deferredLoad.reject();
            script.onload = () => deferredLoad.resolve(Stripe);
            document.head.appendChild(script);
        }
        return deferredLoad.promise;
    };
}



// WEBPACK FOOTER //
// ./stripe/services/stripe-load-sdk.js